import React, { useRef, useState, useEffect } from 'react';
import { View, StyleSheet } from 'react-native';
import BottomSheet from 'react-native-simple-bottom-sheet';

import { isNullOrEmpty } from './common.utils';
import { scaleVertically } from './scale.utils';
import BaseText from '../components/BaseText';
import ChargeOptions from '../components/ChargeOption';

const useChargeBottomSheetActions = (fromExistingReport = false) => {
  const panelRef = useRef(null);
  const isBottomSheetOpenRef = useRef(false);
  const [selectedCharge, setSelectedCharge] = useState(null);
  const expenseChargesRef = useRef();

  const chargeSheetActions = {
    setSelectedCharge: setSelectedCharge,
    unSetSelectedCharge: (TransactionId) => {
      // this to prevent bottom sheet closes in case the user swipes to the right for non-selected charges
      if (selectedCharge?.TransactionId === TransactionId) {
        setSelectedCharge(null);
      }
    },
    forceUnSetSelectedCharge: () => {
      setSelectedCharge(null);
    },
  };

  useEffect(() => {
    const isAlreadyOpen = isBottomSheetOpenRef.current;
    const shouldOpen = !isNullOrEmpty(selectedCharge);
    const shouldClose = isNullOrEmpty(selectedCharge);
    // Only toggle the bottom sheet if its current state differs from the desired action (open/close),
    if ((shouldClose && isAlreadyOpen) || (shouldOpen && !isAlreadyOpen)) {
      panelRef.current.togglePanel();
      isBottomSheetOpenRef.current = !isBottomSheetOpenRef.current;
    }
  }, [selectedCharge]);

  const ChargeBottomSheet = (
    <BottomSheet
      isOpen={!isNullOrEmpty(selectedCharge)}
      ref={(ref) => (panelRef.current = ref)}
      isToggleButtonDisabled={true}
      sliderMinHeight={0} // Hides the bottom sheet button when closed
    >
      <View>
        <BaseText style={styles.bottomSheetBaseText}>Classify your charge</BaseText>
        <View style={styles.bottomSheetView}>
          <ChargeOptions
            selectedCharge={selectedCharge}
            forceUnSetSelectedCharge={chargeSheetActions.forceUnSetSelectedCharge}
            expenseChargesRef={expenseChargesRef}
            fromExistingReport={fromExistingReport}
          />
        </View>
      </View>
    </BottomSheet>
  );

  return [expenseChargesRef, chargeSheetActions, ChargeBottomSheet];
};

const styles = StyleSheet.create({
  bottomSheetBaseText: {
    fontSize: 20,
    marginHorizontal: 'auto',
    marginBottom: scaleVertically(10),
  },
  bottomSheetView: { gap: 10, marginBottom: 10 },
});

export default useChargeBottomSheetActions;
